
import React from 'react';
import { Button } from '@/components/ui/button';
import { PopoverContent } from '@/components/ui/popover';
import { Copy } from 'lucide-react';
import { toast } from 'sonner';

interface SharePopoverContentProps {
    gameTitle: string;
}

const SharePopoverContent = ({ gameTitle }: SharePopoverContentProps) => {
    const shareUrl = window.location.href;
    const shareText = `Check out this game: ${gameTitle}`;
    const twitterShareUrl = `https://twitter.com/intent/tweet?url=${encodeURIComponent(shareUrl)}&text=${encodeURIComponent(shareText)}`;
    const facebookShareUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(shareUrl)}`;
    const whatsappShareUrl = `https://api.whatsapp.com/send?text=${encodeURIComponent(`${shareText} ${shareUrl}`)}`;

    const copyLinkToClipboard = () => {
        navigator.clipboard.writeText(window.location.href);
        toast.success('Game link copied to clipboard!');
    };

    return (
        <PopoverContent className="w-56">
          <div className="grid gap-4">
            <div className="space-y-2">
              <h4 className="font-medium leading-none">Share Game</h4>
              <p className="text-sm text-muted-foreground">
                Share this game with your friends!
              </p>
            </div>
            <div className="grid gap-2">
              <Button variant="outline" onClick={copyLinkToClipboard} className="w-full justify-start">
                <Copy className="mr-2 h-4 w-4" /> Copy Link
              </Button>
              <Button asChild variant="outline" className="w-full justify-start">
                <a href={twitterShareUrl} target="_blank" rel="noopener noreferrer">
                  <svg className="mr-2 h-4 w-4" role="img" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg"><title>Twitter</title><path d="M18.901 1.153h3.68l-8.04 9.19L24 22.846h-7.406l-5.8-7.584-6.638 7.584H.474l8.6-9.83L0 1.154h7.594l5.243 6.932ZM17.61 20.644h2.039L6.486 3.24H4.298Z"/></svg>
                  Share on Twitter
                </a>
              </Button>
              <Button asChild variant="outline" className="w-full justify-start">
                <a href={facebookShareUrl} target="_blank" rel="noopener noreferrer">
                <svg className="mr-2 h-4 w-4" role="img" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg"><title>Facebook</title><path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/></svg>
                  Share on Facebook
                </a>
              </Button>
              <Button asChild variant="outline" className="w-full justify-start">
                <a href={whatsappShareUrl} target="_blank" rel="noopener noreferrer">
                <svg className="mr-2 h-4 w-4" role="img" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg"><title>WhatsApp</title><path d="M12.04 2.162c-5.52 0-9.99 4.47-9.99 9.99 0 1.77.46 3.48 1.31 4.96L2 22l5.05-1.32c1.45.82 3.11 1.28 4.99 1.28h.01c5.52 0 9.99-4.47 9.99-9.99s-4.47-9.99-9.99-9.99zM12.04 21.61c-1.57 0-3.1-.38-4.45-1.1l-.32-.19-3.3 1.15 1.17-3.23-.21-.34c-.81-1.35-1.24-2.89-1.24-4.52 0-4.62 3.75-8.37 8.37-8.37s8.37 3.75 8.37 8.37-3.75 8.37-8.37 8.37zm4.55-5.93c-.25-.12-1.47-.72-1.7-.81-.23-.08-.39-.12-.56.12-.17.25-.64.81-.79.97-.15.17-.29.19-.54.06-.25-.12-1.06-.39-2.02-1.25-.75-.66-1.25-1.48-1.4-1.73-.14-.25-.01-.39.11-.5.11-.11.25-.29.37-.43.13-.15.17-.25.25-.41.08-.17.04-.31-.02-.43-.06-.12-.56-1.34-.76-1.84-.2-.48-.41-.42-.56-.42h-.48c-.17 0-.43.06-.66.31-.22.25-.87.85-.87 2.07 0 1.22.89 2.4 1.01 2.56.12.17 1.76 2.68 4.27 3.76 2.51 1.08 2.51.72 2.96.69.45-.03 1.47-.6 1.68-1.18.21-.58.21-1.08.14-1.18-.05-.12-.19-.19-.44-.31z"/></svg>
                  Share on WhatsApp
                </a>
              </Button>
            </div>
          </div>
        </PopoverContent>
    );
}
export default SharePopoverContent;
